import React from 'react'
import PropTypes from 'prop-types'
import './Label.sass'

const Label = ({children, bsStyle}) => (
  <div className={`label label--${bsStyle}`}>
    {children}
  </div>
)

Label.propTypes = {
  children: PropTypes.node.isRequired,
  bsStyle: PropTypes.string
}

Label.defaultProps = {
  bsStyle: 'default'
}

export default Label



// WEBPACK FOOTER //
// ./components/Label/index.jsx